import { FeatureFlagsEnum } from '../enums/feature-flags.enum';

export class DefaultFlags {
	private static readonly DEFAULT_FLAGS = {
		[FeatureFlagsEnum.CHECKIN_WITH_SELFIE]: { enabled: true },
		[FeatureFlagsEnum.ENABLE_TINY_FACE_DETECTOR_WITHDRAWAL]: { enabled: false },
		[FeatureFlagsEnum.PARAMS_RESOLUTION_PHOTO_WITHDRAWAL]: {
			enabled: false,
			value: JSON.stringify({ height: 800, width: 600 }),
		},
		[FeatureFlagsEnum.PARAMS_TINY_FACE_DETECTOR]: {
			enabled: false,
			value: JSON.stringify({ inputSize: 160, scoreThreshold: 0.8, scoreAccept: 0.899999 }),
		},
		[FeatureFlagsEnum.ENABLE_LIVENESS]: {
			enabled: false,
		},
	};

	// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
	static getDefaultFlags(): Record<FeatureFlagsEnum, { enabled: boolean; value?: FeatureFlagValue }> {
		return { ...this.DEFAULT_FLAGS };
	}
}

type FeatureFlagValue = string | number | boolean | null;
